module.exports = __webpack_public_path__ + "static/media/5.46b1d16e.jpg";